import Link from "next/link";
import Button from "../ui-kit/buttons/Button";
import CustomHighlight from "./Highlight";
import { connectHits } from 'react-instantsearch-dom';
import { GetImgUrl } from "../../utils/ImageUtils";

const Hits = ({ hits }) => hits.map((hit, idx) => <ProjectHit hit={hit} key={idx} />);
const CustomHits = connectHits(Hits);


const ProjectHit = (props) => {
  const url = `/proyectos/${props.hit.slug}`;

  const imgSrc = GetImgUrl(props.hit.image.url);
  return (
    <div className="flex flex-col rounded shadow-xl dark:shadow-none dark:bg-theme-dark-light">
      <Link href={url}>
        <a>
          <div className="aspect-w-16 aspect-h-9">
            <img
              className="object-cover bg-red-100 rounded"
              src={imgSrc}
              alt={props.hit.title}
            />
          </div>
        </a>
      </Link>
      <div className="p-4 space-y-4">
        <Link href={url}>
          <a>
            <div className="text-lg font-bold text-primary">
              <CustomHighlight attribute="title" hit={props.hit} />
            </div>
          </a>
        </Link>
        <div className="hit-description">
          <CustomHighlight attribute="description" hit={props.hit} />
        </div>
        <div className="">
          {/* <CustomHighlight attribute="keywords" hit={props.hit} /> */}
        </div>
        <div className="md:hidden">
          <Link href={url}>
            <a>
              <Button type="primary" className="bg-highlight-yellow" size="sm" block>Ver Detalles</Button>
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
}

export { CustomHits, ProjectHit };